export default {
  CRM: 1,
  RESERVE: 2,
}



// WEBPACK FOOTER //
// ./src/consts/serverTypes.js